function hasHeader(headers, headerName) {
  const normalizedHeaderName = headerName.toLowerCase();
  return Object.keys(headers).some(key => key.toLowerCase() === normalizedHeaderName);
}

export function buildAuthHeaders(options = {}, hasJsonBody = false, token = null) {
  const headers = { ...(options.headers || {}) };

  if (hasJsonBody && !hasHeader(headers, "Content-Type")) {
    headers["Content-Type"] = "application/json";
  }

  if (options.useAuth !== false && !hasHeader(headers, "Authorization")) {
    const authToken = options.authToken || token;
    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }
  }

  return headers;
}
